"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../theme");
exports.useStyles = (0, react_jss_1.createUseStyles)({
    component: {
        display: "flex",
        gap: (0, theme_1.space)(2),
        border: "1px solid ".concat(theme_1.colors.neutral30),
        padding: (0, theme_1.space)(4),
        "&:hover": {
            borderColor: theme_1.colors.neutral50,
        },
    },
    relation: {
        "--relation-color": theme_1.colors.primary,
        "--relation-hover-color": theme_1.colors.primaryDark,
        display: "flex",
        borderRight: "4px solid var(--relation-color)",
        paddingRight: (0, theme_1.space)(2),
        paddingBlock: (0, theme_1.space)(4),
    },
    relation_and: {
        "--relation-color": "#1E88E5",
        "--relation-hover-color": "#1565C0",
    },
    relation_or: {
        "--relation-color": "#FFC107",
        "--relation-hover-color": "#FFB300",
        borderRightStyle: "dotted",
    },
    relationButton: {
        "--button-color": "var(--relation-color) !important",
        "--button-hover-color": "var(--relation-hover-color) !important",
        width: 60,
        alignSelf: "center",
    },
    entries: {
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        justifyContent: "center",
        gap: (0, theme_1.space)(2),
    },
    entry: {
        display: "flex",
        gap: (0, theme_1.space)(2),
    },
    entryControls: {
        display: "flex",
        alignContent: "center",
    },
    entryDelete: {
        alignSelf: "center",
    },
    addWrapper: {
        display: "flex",
        gap: (0, theme_1.space)(4),
    },
    addEntryButton: {
        fontWeight: "normal",
    }
});
